import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { UserRole } from '../../types';

interface RoleGuardProps {
  children: React.ReactNode;
  roles: UserRole[];
  /** Redirect-Ziel bei fehlender Berechtigung (Standard: /dashboard) */
  redirectTo?: string;
}

/**
 * Rollenbasierter Route Guard.
 * Prüft ob der eingeloggte Benutzer eine der geforderten Rollen hat.
 * Falls nicht → Redirect auf Dashboard.
 *
 * Verwendung:
 * <RoleGuard roles={['ADMIN', 'GLOBAL_ADMIN']}>
 *   <SettingsPage />
 * </RoleGuard>
 */
const RoleGuard: React.FC<RoleGuardProps> = ({
  children,
  roles,
  redirectTo = '/dashboard',
}) => {
  const { user } = useAuthStore();

  if (!user || !roles.includes(user.role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;
